import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreUsersSelfModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ApplicationSuccessfulModalComponent } from './application-successful-modal.component';

@NgModule({
  imports: [CommonModule, DatastoreUsersSelfModule, UiModule, TrackingModule],
  declarations: [ApplicationSuccessfulModalComponent],
})
export class ApplicationSuccessfulModalModule {}
